import React, {useState} from "react";
import {
  useParams,
  useNavigate,
  Link
} from 'react-router-dom';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import SearchPagePC from './SearchPagePC';
import SearchPageMobile from './SearchPageMobile';
import SearchPageTablet from './SearchPageTablet';


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function SearchPage(props) {

    const onPreviewMoments = (object, user) => {
     props.onPreviewMoments(object, user);
    }

    const onPreviewCredits = (object, user) => {
      props.onPreviewCredits(object, user);
    }


    return (

        <div style={{width: viewportWidth+'px'}}>

              {!isMobileOnly && !isTablet &&
                <BrowserView>
                  <SearchPagePC {...props} onPreviewMoments={onPreviewMoments} onPreviewCredits={onPreviewCredits}/>
               </BrowserView>
             }

              {isMobileOnly &&
        			  <MobileView>
        	         <SearchPageMobile {...props} onPreviewMoments={onPreviewMoments} onPreviewCredits={onPreviewCredits}/>
        			 </MobileView>
        			}

        			{isTablet &&
        			  <TabletView>
        			     <SearchPageTablet {...props} onPreviewMoments={onPreviewMoments} onPreviewCredits={onPreviewCredits}/>
        			  </TabletView>
        			}

        </div>

    );




}
